import { render, staticRenderFns } from "./OnlineTest.vue?vue&type=template&id=922bd1f0"
import script from "./OnlineTest.vue?vue&type=script&lang=js"
export * from "./OnlineTest.vue?vue&type=script&lang=js"
import style0 from "./OnlineTest.vue?vue&type=style&index=0&id=922bd1f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports